import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import Svg from "@natera/material/lib/svg";

import SearchCloudIcon from "@assets/svg/search-cloud.svg";
import SearchCloudIconDesktop from "@assets/svg/desktop/search-cloud-desktop.svg";
import { ConfigContext } from "@app/provider";
import useScreenSize from "@app/hooks/useScreenSize";

import "./noLongerAvailableCard.scss";

const minDesktopWidth = 768;

const messages = defineMessages({
  noLongerAvailableCardTitle: {
    id: "noLongerAvailableCardTitle",
    defaultMessage: "Billing update no longer available",
  },
  noLongerAvailableCardDescription1: {
    id: "noLongerAvailableCardDescription1",
    defaultMessage: "We'll continue processing with your insurance.",
  },
  noLongerAvailableCardDescription2: {
    id: "noLongerAvailableCardDescription2",
    defaultMessage: "While we do that, feel free to explore next steps.",
  },
  noLongerAvailableCardHelp: {
    id: "noLongerAvailableCardHelp",
    defaultMessage: "Need more help?",
  },
  noLongerAvailableCardContactUs: {
    id: "noLongerAvailableCardContactUs",
    defaultMessage: "Contact Us",
  },
});

const NoLongerAvailableCard: React.FC = () => {
  const intl = useIntl();
  const { config } = React.useContext(ConfigContext);
  const { screenWidth } = useScreenSize();

  return (
    <div className="no-longer-available-card__box">
      <div className="no-longer-available-card__box-icon">
        {screenWidth < minDesktopWidth ? (
          <Svg content={SearchCloudIcon} />
        ) : (
          <Svg content={SearchCloudIconDesktop} />
        )}
      </div>
      <div className="no-longer-available-card__box-content">
        <div className="no-longer-available-card__box-content__title">
          {intl.formatMessage(messages.noLongerAvailableCardTitle)}
        </div>
        <div className="no-longer-available-card__box-content__text">
          <div>
            {intl.formatMessage(messages.noLongerAvailableCardDescription1)}
            {intl.formatMessage(messages.noLongerAvailableCardDescription2)}
          </div>
        </div>
        <div className="no-longer-available-card__box-content__contact">
          <span>{intl.formatMessage(messages.noLongerAvailableCardHelp)} </span>
          <span className="no-longer-available-card__box-content__contact-us">
            <Link
              target="_blank"
              key="privacyPolicy"
              rel="noopener noreferrer"
              to={config.links.CONTACT_US}
            >
              {intl.formatMessage(messages.noLongerAvailableCardContactUs)}
            </Link>
          </span>
        </div>
      </div>
      <div className="no-longer-available-card__divider" />
    </div>
  );
};

export default NoLongerAvailableCard;
